import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import api from "@/lib/api";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32 pb-24" data-testid="blog-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading overline="Travel Guides" title={<>Stories worth <span className="font-light italic">packing for.</span></>} className="mb-16" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-testid="blog-grid">
          {blogs.map((b, i) => (
            <Reveal key={b.slug} delay={(i % 2) * 0.1}>
              <Link to={`/blog/${b.slug}`} className="group block" data-testid={`blog-card-${b.slug}`}>
                <div className="overflow-hidden rounded-2xl aspect-[16/10] mb-5">
                  <img src={b.image} alt={b.title} loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-108 group-hover:scale-105" />
                </div>
                <p className="text-xs uppercase tracking-[0.2em] text-sun mb-2">{b.tag} · {b.read_time}</p>
                <h2 className="font-display text-2xl font-bold leading-snug mb-2 group-hover:text-sun transition-colors">{b.title}</h2>
                <p className="text-ink/60 text-sm leading-relaxed mb-3">{b.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold">Read guide <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
